import classNames from "classnames/bind";
import styles from "./CurrentRole.module.css";
import { useCallback, useContext, useEffect, useState } from "react";
import axiosClient from "../../../../../services/axiosClient";
import { WaitConfirmContext } from "../../../../../contexts";
import { Button, SelectBox, SelectBoxItem, Toast } from "../../../../../components";
import { Previous } from "../../../../../components/Icons/Icons";
import { userManagement } from "../../../../../services/api/userManagementApi";

const cx = classNames.bind(styles);

function CurrentRole({ onBack, onClose }) {
    const { codeCompany, userData , isRefresh, setIsRefresh} = useContext(WaitConfirmContext)
    const [listRole, setListRole] = useState([]);
    const [roleCode, setRoleCode] = useState();
    useEffect(() => {
        const getListRole = async () => {
            try {
                const res = await axiosClient.get(`userType/get-list-userType/?company_code=${codeCompany}`);
                setListRole(res.data)
            } catch (error) {
                Toast.open('Lấy danh sách quyền đã có không thành công', 'danger')
            }
        }
        getListRole()
    }, [codeCompany])

    const handleAccept = useCallback(async () => {
        if (roleCode) {
            try {
                const data = {
                  usertype_code: roleCode
                }
                const res = await userManagement.verify({userName: userData.userName, data: data});
                Toast.open("Xác nhận thành công", "success");
                setIsRefresh(!isRefresh);
                onClose()
                return res;
            } catch (e) {
                Toast.open("Xác nhận không thành công", "danger");
            }
        } else {
            Toast.open("Bạn chưa chọn quyền", "danger");
        }
    }, [userData, roleCode])

    const handleChangeRole = (data) => {
        setRoleCode(data)
    }
    return (
        <div>
            <div id="__notification"></div>
            <button className={cx('button-back')} onClick={onBack}> <Previous /> Trở lại</button>
            <div className={cx('selection')}>
                {listRole.length > 0 && (
                    <SelectBox title={'Chọn phân quyền'} onChange={handleChangeRole}>
                        {listRole.length > 0 && listRole?.map((item) => {
                            return (
                                <SelectBoxItem key={item.CODE} value={item.CODE} label={item.SUBJECT_NAME} />
                            )
                        })}
                    </SelectBox>
                )}
            </div>
            <div className={cx('control')}>
                <Button title={'Hủy bỏ'} className={cx('btn-cancel')} onClick={onBack} />
                <Button title={'Xác nhận'} className={cx('btn-accept')} onClick={handleAccept} />
            </div>
        </div>
    )
}

export default CurrentRole;